export default "__VITE_ASSET__qzLxJG9y__"